import * as React from 'react';
import { SelectedChoices } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const SelectedTypeContainer = ({ urls , store , type , onClick  })=>{
    const { getLabel  } = useIntl();
    const choices = React.useMemo(()=>{
        return {
            type: {
                name: type.name,
                action: getLabel('appointments.component.selectedChoices.change'),
                onClick: ()=>{
                    /* this exists because we need to fire some dataLayer events onClick
          when this is used in stores detail page but at the same time we want
          to keep the component generic in case it is used in another page */ onClick === null || onClick === void 0 ? void 0 : onClick();
                    window.location.assign(`${urls.bookAppointment}/what?storeId=${store.code}`);
                }
            }
        };
    }, [
        getLabel,
        urls,
        store,
        type
    ]);
    return /*#__PURE__*/ React.createElement(SelectedChoices, {
        choices: choices
    });
};

export { SelectedTypeContainer, SelectedTypeContainer as default };
//# sourceMappingURL=SelectedTypeContainer.js.map
